import { FC, useMemo, useCallback } from 'react'
import { accountActionsMap, shouldConfirmDeletion } from 'helpers/linkageHelpers'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { confirmMixedAccountOperationActionCreator, performMixedAccountOperationActionCreator } from 'actions/linkageActions'
import { MixedAccountsTableItem } from 'selectors/linkageSelectors'

type AccountActionDeleteHandlerProps = {
  accountInfo: MixedAccountsTableItem
}

export const AccountActionDeleteHandler: FC<AccountActionDeleteHandlerProps> = (props) => {
  const { accountInfo, children } = props
  const { providerAccountState, account, type, providerAccount } = accountInfo
  const { notification_type, actions } = providerAccountState
  const dispatch = useStoreDispatch()

  const handleClick = useCallback(() => {
    const currentAccount = type === 'manual'
      ? account
      : account || providerAccount

    if (!currentAccount) {
      return
    }

    if (shouldConfirmDeletion(currentAccount.cid, notification_type)) {
      dispatch(confirmMixedAccountOperationActionCreator(currentAccount, 'delete'))
    } else {
      dispatch(performMixedAccountOperationActionCreator.request({ account: currentAccount, operation: 'delete' }))
    }
  }, [dispatch, notification_type, account, type, providerAccount])

  const isExist = useMemo(() => {
    const actionsMap = accountActionsMap(actions)
    return !!actionsMap.delete
  }, [actions])

  if (!isExist) {
    return null
  }

  return (
    <div onClick={ handleClick }>
      { children }
    </div>
  )
}
